import { AddUpdateTripDTO, TripFormFields } from 'types';
import { parseDayjsDateIntoString } from '../dateTime/parseDayjsDateIntoString';

export const parseTripFormFieldsIntoAddUpdateTripDTO: (
    tripFormFields: TripFormFields,
) => AddUpdateTripDTO = ({ date, ...restTripFormFieldsData }) => ({
    ...restTripFormFieldsData,
    date: parseDayjsDateIntoString(date, 'YYYY-MM-DD'),
});
